export enum MAINSCREEN_RESULT_STEPS {
  INITIAL = "INITIAL",
  CORRECTNESS = 'CORRECTNESS',
  COMPLETE = 'COMPLETE',
  RESULT = 'RESULT'
}

export enum APP_MODE {
  GAME = 'GAME',
  WORDLIST = 'WORDLIST'
}